<app-offcanvas-header header="{{isEdit ? 'Edit' : 'Add'}} Department"
(closeClicked)="onCloseIconClick(false)"></app-offcanvas-header>
<div class="offCanvas__container">
  <div class="offCanvas__contentWrapper">
    <form class="mt-2" [formGroup]="departmentFormGroup">
      <div class="offcanvas__content">
        <div class="offcanvas__orgDetails">
          <div class="offCanvas__orgName-inputField">
            <app-input-filed label="Name" placeholder="Enter Name" [toUpperCase]="true"
            [control]="$any(departmentFormGroup).controls['name']" [starIcon]="'*'"></app-input-filed>
            @if (departmentFormGroup.controls?.['name']?.invalid &&
              (departmentFormGroup.controls?.['name']?.dirty ||
              departmentFormGroup.controls?.['name']?.touched)) {
              <div>
                @if (departmentFormGroup.controls?.['name']?.errors?.['required']) {
                  <div>
                    <small class="text-danger">Name is required.</small>
                  </div>
                }
              </div>
            }
          </div>
          @if (errorMessage) {
            <p class="text-danger m-2">{{errorMessage}}</p>
          }
        </div>
      </div>
    </form>
  </div>
  <div class="offCanvas__footer">
    <app-common-button (clickEvent)="onCloseIconClick(false)" buttonClass="smallbutton"
    buttonLabel="Cancel"></app-common-button>
    @if (commonService.orgLock()) {
      <app-common-button (clickEvent)="onSubmit()" [loadingIcon]="verifyLoader" buttonClass="smallFilledButton"
        [buttonLabel]="selectedDepartment ? 'Update' : 'Save'"
      [disabled]="(departmentFormGroup.invalid || selectedDepartment?.name == departmentFormGroup.controls['name'].value)"></app-common-button>
    }
  </div>
</div>